<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-if="active">
    <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" fill="#413887" d="M41.999 45.999h-38c-1.104 0-3.999.951-3.999-4v-38C0 2.895.15 0 3.999 0h38c3.98 0 4 2.895 4 3.999v38c0 3.98-2.895 4-4 4zm-30-39A5 5 0 1 0 12 17 5 5 0 0 0 12 7zm24.5 16h-27a2.5 2.5 0 0 0 0 5h27a2.5 2.5 0 1 0 0-5zm0 10h-27a2.5 2.5 0 0 0 0 5h27a2.5 2.5 0 1 0 0-5z"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" v-else>
    <path xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" fill="#333" d="M41.999 45.999h-38c-1.104 0-3.999.951-3.999-4v-38C0 2.895.15 0 3.999 0h38c3.98 0 4 2.895 4 3.999v38c0 3.98-2.895 4-4 4zm1-41a2 2 0 0 0-2-2h-36a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h36a2 2 0 0 0 2-2v-36zm-6.5 33h-27a2.5 2.5 0 0 1 0-5h27a2.5 2.5 0 0 1 0 5zm0-10h-27a2.5 2.5 0 0 1 0-5h27a2.5 2.5 0 0 1 0 5zm-24.5-11a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/>
  </svg>
</template>
<script>
export default {
  props:{
    active:Boolean
  }
}
</script>